import {Component, OnDestroy, OnInit} from '@angular/core';
import {HttpErrorResponse} from "@angular/common/http";
import {takeUntil} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Support} from "../../../shared/interface/support";
import {SupportService} from "../../../shared/services/support.service";

@Component({
  selector: 'app-support-details',
  templateUrl: './support-details.component.html',
  styleUrls: ['./support-details.component.scss']
})
export class SupportDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  supportId: string;
  supportObject?: Support;
  support: ReplaySubject<Support> = new ReplaySubject<Support>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;
  constructor( private route: ActivatedRoute,
               private supportService: SupportService,
               private snack: MatSnackBar,
               private dialog: MatDialog,
               private auth: AuthService,
  )
  {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.supportId = params.id;
        this.loadSupport();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadSupport(): void {
    this.supportService.get(this.supportId).subscribe((support: Support) => {
      this.support.next(support);
      this.supportObject = support;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
